import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { connect } from 'react-redux';
import { niceDateTimeFormatter } from '../../lib/helper/formatting';
import { consultantInsuranceFeeAuditLogFetch, consultantInsuranceFeeAuditLogUnload } from '../../lib/redux/actions/consultant';

const mapStateToProps = (state) => ({
  insuranceFeeAuditLog: state.consultantSingle.insuranceFeeAuditLog,
  isFetchingInsuranceFeeAuditLog: state.consultantSingle.isFetchingInsuranceFeeAuditLog,
});

const mapDispatchToProps = {
  consultantInsuranceFeeAuditLogFetch,
  consultantInsuranceFeeAuditLogUnload,
};

class ConsultantInsuranceFeeAuditLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { filter: '' };
  }

  componentDidMount() {
    const { consultant, consultantInsuranceFeeAuditLogFetch } = this.props;
    consultantInsuranceFeeAuditLogFetch(consultant['@id']);
  }

  componentWillUnmount() {
    this.props.consultantInsuranceFeeAuditLogUnload();
  }

  getFilteredLogs() {
    const { insuranceFeeAuditLog } = this.props;
    const { filter } = this.state;
    if (!insuranceFeeAuditLog) return [];
    const reversed = [...insuranceFeeAuditLog].reverse();
    if (!filter.trim()) return reversed;
    const term = filter.toLowerCase();
    return reversed.filter((log) => {
      const date = niceDateTimeFormatter(log.createdAt) || '';
      const user = log.createdByNiceName || 'Portal';
      const insurer = log.insurerNiceName || '';
      const value = log.niceNewValue || '';
      return (
        date.toLowerCase().includes(term) || user.toLowerCase().includes(term) || insurer.toLowerCase().includes(term) || value.toLowerCase().includes(term)
      );
    });
  }

  render() {
    const { insuranceFeeAuditLog, isFetchingInsuranceFeeAuditLog } = this.props;
    const { filter } = this.state;
    const filteredLogs = this.getFilteredLogs();

    return (
      <Row>
        <Col>
          <Card body>
            {/*<Card.Header className={'text-center card-header--small-text'}>Fee Assured Audit Log</Card.Header>*/}
            {/*<Card.Body>*/}
            {isFetchingInsuranceFeeAuditLog && <p className="mb-0 text-center text-muted">Loading...</p>}
            {!isFetchingInsuranceFeeAuditLog && (!insuranceFeeAuditLog || insuranceFeeAuditLog.length === 0) && (
              <p className="mb-0 text-center text-muted">No audit log entries found.</p>
            )}
            {insuranceFeeAuditLog && insuranceFeeAuditLog.length > 0 && (
              <>
                <input
                  type="text"
                  className="form-control form-control-sm mb-2"
                  placeholder="Filter log..."
                  value={filter}
                  onChange={(e) => this.setState({ filter: e.target.value })}
                />
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                  <table className="table table-sm table-striped mb-0">
                    <thead>
                      <tr>
                        <th>At</th>
                        <th>By</th>
                        <th>Insurer</th>
                        <th>Fee Assured</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredLogs.map((log) => (
                        <tr key={log.id} data-logid={log.id}>
                          <td className="text-nowrap">{niceDateTimeFormatter(log.createdAt)}</td>
                          <td>{log.createdByNiceName ? log.createdByNiceName : 'Portal'}</td>
                          <td>{log.insurerNiceName}</td>
                          <td>
                            <strong>{log.niceNewValue}</strong>
                          </td>
                        </tr>
                      ))}
                      {filteredLogs.length === 0 && (
                        <tr>
                          <td colSpan={4} className="text-center text-muted">
                            No matching entries.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
            {/*</Card.Body>*/}
          </Card>
        </Col>
      </Row>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultantInsuranceFeeAuditLog);
